import { get } from "lodash";
import curryConnector from "utils/connectors";

export const USER_IMPORT_LOG_STATE_KEY = "userImportLog";

export const ActionTypes = {
  LOADING_USER_IMPORT_LOG: "LOADING_USER_IMPORT_LOG",
  ERROR_LOADING_USER_IMPORT_LOG: "ERROR_LOADING_USER_IMPORT_LOG",
  LOADED_USER_IMPORT_LOG: "LOADED_USER_IMPORT_LOG",
};

export const USER_IMPORT_LOG_PAGE_SIZE = 10;
export const USER_IMPORT_LOG_PAGE_SIZE_OPTIONS = [5, 10, 25, 50];

const initialState = {
  userImportLog: [],
  loading: false,
  error: null,
  loaded: false,
  pageInfo: { pageNumber: 1, pageSize: USER_IMPORT_LOG_PAGE_SIZE, totalRecords: 0 },

};

const curry = fn => curryConnector(fn, USER_IMPORT_LOG_STATE_KEY);

export default ((state, action) => {
  switch (action.type) {
    case ActionTypes.LOADING_USER_IMPORT_LOG:
      return { ...state, loading: true, loaded: false, error: null };

    case ActionTypes.ERROR_LOADING_USER_IMPORT_LOG:
      return { ...state, loading: false, loaded: false, error: action.payload.message };

    case ActionTypes.LOADED_USER_IMPORT_LOG:
      return {
        ...state,
        loading: false,
        error: null,
        loaded: true,
        userImportLog: action.payload.userImportLog,
        pageInfo: action.payload.pageInfo,
      };

    default:
      return state || initialState;
  }
});

export const isUserImportLogLoading = curry(({ localState }) => get(localState, ["loading"], false) === true);

export const isUserImportLogLoadingError = curry(({ localState }) => get(localState, ["error"], null));

export const isUserImportLogLoaded = curry(({ localState }) => get(localState, ["loaded"], false) === true);

export const getUserImportLog = curry(({ localState }) => get(localState, ["userImportLog"], null));

export const getPageInfo = curry(({ localState }) => localState.pageInfo);

export const getErrorMessage = curry(({ localState }) => {
  const error = get(localState, ["error"], null);
  if (!error) return null;
  return error;
});
